import api from '../../../services/Api';
import { IAuditoriaAnomaliaTarifaBancariaResultado } from '../interfaces/IAuditoriaAnomaliaTarifaBancaria';

export const AuditoriaAnomaliaTarifaBancariaService = {
  async buscarResultado(params: {
    empresaId: number;
    periodo?: string;
  }): Promise<IAuditoriaAnomaliaTarifaBancariaResultado> {
    const response = await api.get<IAuditoriaAnomaliaTarifaBancariaResultado>('auditoria-anomalia-tarifa-bancaria/resultado', {
      params: {
        empresaIds: params.empresaId,
        periodo: params.periodo || '',
      },
    });

    return (
      response.data || {
        impactoFiscalTotal: 0,
        impactoFinanceiroTotal: 0,
        totalAvisos: 0,
        totalAlertas: 0,
        totalErros: 0,
        status: 'CONCILIADO',
        mensagemDirecionamento: '',
        fundamentacaoFiscal: '',
        fundamentacaoContabil: '',
        anomaliasDetectadas: [],
        tarifasRegulares: [],
      }
    );
  },
};
